const TypeDeProfessionelReducer =  (state = [], action) => {
      return state
}

export default TypeDeProfessionelReducer;
